<script lang="ts" setup>
import type { IconName } from '~ds/lib/icons';

import { Icon } from '~ds/components/ui/icon';
import { ICONS } from '~ds/lib/icons';

interface Props {
  text: string;
  icon?: IconName;
}

withDefaults(defineProps<Props>(), {
  icon: ICONS.plus,
});
</script>

<template>
  <span class="flex w-max items-center gap-2 rounded-full bg-white/80 pr-1 pl-3 py-1 text-xs font-normal tracking-normal backdrop-blur-sm md:text-xs lg:text-sm">
    {{ text }}
    <span class="flex aspect-square size-5 shrink-0 items-center justify-center rounded-full bg-primary md:size-6">
      <Icon
        :name="icon"
        size="sm"
        class="text-white"
      />
    </span>
  </span>
</template>
